import { defineStyle, defineStyleConfig, ComponentStyleConfig } from '@chakra-ui/react';

const allcaps = defineStyle({
  textTransform: 'uppercase',
  fontWeight: '500',
  letterSpacing: 'wider'
});

export const headingTheme: ComponentStyleConfig = defineStyleConfig({
  baseStyle: {
    fontWeight: '700',
    letterSpacing: 'tighter'
  },
  variants: {
    allcaps
  }
});
